export default __webpack_public_path__ + "static/media/endorphina.01975d23.svg";